import React, { useMemo } from "react";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";
import { HgSic } from "../../../types/taxonomy";
import TreeSelect from "../TreeSelect/TreeSelect";
import { transformToTree } from "../TreeSelect/utils";
import { INDUSTRY_MESSAGES } from "./constants";

interface SicInputProps {
  onSicSelect: (sicIds: string[]) => void;
  selectedItems: string[];
  id?: string;
}

export const SicInput: React.FC<SicInputProps> = ({
  onSicSelect,
  selectedItems = [],
  id = "sic-input",
}) => {
  const { sic } = useTaxonomyContext();

  const allOptions = useMemo(
    () => transformToTree(sic as HgSic[], (i) => `${i.code}: ${i.name}`),
    [sic]
  );

  return (
    <TreeSelect
      id={id}
      items={allOptions}
      selectedItems={selectedItems}
      onSelectItems={onSicSelect}
      placeholder={INDUSTRY_MESSAGES.PLACEHOLDER}
      noOptionsMessage={INDUSTRY_MESSAGES.NO_RESULTS}
    />
  );
};
